import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="page error-bg">
      <div className="row authentication coming-soon justify-content-center g-0 my-auto">
        <div className="col-xxl-5 col-xl-5 col-lg-7 col-md-7 col-sm-9 col-11 my-auto">
          <div className="rounded">
            <div className="bg-white p-5 error-img text-center rounded">
              <p className="error-text mb-4">404</p>
              <p className="fs-5 fw-medium mb-2">
                Oops, the page you are trying to access does not exist.
              </p>
              <p className="fs-15 mb-4 text-muted">
                The page may have been moved, deleted, or never existed.
              </p>
              <Link
                to="/"
                className="btn btn-lg btn-w-lg mb-2 border-0 btn-primary waves-effect waves-light"
              >
                Home Page
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
